import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthForm from '../components/auth/AuthForm';
import { useAuth } from '../hooks/useAuth';

export default function AuthPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      // Redirect to the attempted URL or home
      const from = (location.state as any)?.from || '/';
      navigate(from, { replace: true });
    }
  }, [user, navigate, location]);

  return (
    <div className="min-h-[calc(100vh-4rem)] bg-[#F4F2EE] flex items-center justify-center p-4">
      <AuthForm />
    </div>
  );
}